export const MODULES_IN_RICHTEXT = 'hs_modules_in_richtext';
export const ScpModuleInsertionKeys = {
  HS_MODULE_SCHEMA: 'hs_module_schema',
  HS_FIELD_OVERRIDES: 'hs_field_overrides'
};